/* eslint-disable prefer-arrow/prefer-arrow-functions */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable @typescript-eslint/member-ordering */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import {map} from 'rxjs/operators';
import { User } from '../models/user.model';

@Injectable({
  providedIn: 'root'
})

export class AccountService {

  homepageRoutes = {
    Admin: '/',
    Manager: '/admin/manage-users',
    Employee: '/admin/manage-visits',
    Operater:'/admin/manage-visitors' 
  }

  apiUrl = environment.apiUrl;
  private currentUserSource = new ReplaySubject<User>(1);
  currentUser$ = this.currentUserSource.asObservable();

  constructor(private http: HttpClient) { }

  login(model: any) {
    return this.http.post(this.apiUrl + 'user/login', model).pipe(
      map((tokenRes) =>{
        if (tokenRes) {
          const user = {...this.parseJwt(tokenRes['token']), token: tokenRes['token']};
          localStorage.setItem('loggedUser', JSON.stringify(user));
          this.currentUserSource.next(user);
          return user;
        }
      })
    );
  }

  parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  };

  setCurrentUser(user: User) {
    this.currentUserSource.next(user);
  }

  logout() {
    localStorage.removeItem('loggedUser');
    this.currentUserSource.next(null);
  }

  isAdminWithoutRoom() {
    let isAdminWithoutRoom = true;
    this.currentUser$.subscribe(jwt => {
      const user = this.parseJwt(jwt['token'])
      const roomId = parseInt(user['roomId']);
      if(roomId && roomId > 0) {
        isAdminWithoutRoom = false;
      }
    })
    return isAdminWithoutRoom;
  }
}
